var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.233 131.233",
    height: 496,
    width: 496,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10016.2 16300v-625.9l376.2 313-376.2 312.9",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.10174 0 0 -.10174 -1017.944 1696.2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.10295316
    },
    d: "M119.699 183.83H11.24c-5 0-9.19 3.665-10.01 8.442l50.59 42.077 8.443 7.011c2.862 2.389 7.557 2.389 10.419 0L79.547 234l50.18-41.727c-.835-4.777-5.014-8.442-10.028-8.442",
    transform: "translate(0 -165.767)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11282.1 15674.1v625.9l-376.3-312.9 376.3-313",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.10174 0 0 -.10174 -1017.944 1696.2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11017.4 16240.2-69-57.3c-28.8-23.9-76-23.9-104.8 0l-88.9 73.9-51.8 43.2-416-345.9c17.5-14.1 39.6-22.5 63.7-22.5h1090.8c24.1 0 46.3 8.4 63.8 22.5l-416.1 345.9-71.7-59.8",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.09943 0 0 -.09943 -1017.944 1696.2)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4475dec1c40926aa6e0e0e9bee6b43b9.svg";
export { ForwardRef as ReactComponent };